<template>
  <div
    v-if="state === inlineActionConfirmationState.CONFIRM"
    class="
      tw-flex tw-gap-2 tw-h-8 tw-py-0 tw-px-1
      -tw-my-1
      tw-bg-sf-neutral-lighter-1 tw-rounded-lg tw-items-center
    "
  >
    <slot
      name="confirm-action"
      :disabled="disabled"
      :handle-confirm="handleConfirm"
    >
      <SfButtonDs
        variant="danger"
        size="sm"
        icon-before="trash"
        :disabled="disabled"
        @click="handleConfirm"
      >
        {{ I18n.t('common.remove') }}
      </SfButtonDs>
    </slot>

    <SfButtonDs
      variant="secondary"
      size="sm"
      :disabled="disabled"
      @click="handleCancel"
    >
      {{ I18n.t('common.cancel') }}
    </SfButtonDs>
  </div>
  <div v-show="state === inlineActionConfirmationState.FREE">
    <slot :open-confirmation="openConfirmation" />
  </div>
</template>
<script setup lang="ts">
import type { InlineActionConfirmationState } from './constants'

import { ref } from 'vue'

import { inlineActionConfirmationState } from './constants'
import useI18n from '@app/shared/vue/composables/use-I18n'
import { SfButtonDs } from '@silverfin/ui-components'

const I18n = useI18n()

interface Props {
  disabled?: boolean
}

defineProps<Props>()

const state = ref<InlineActionConfirmationState>(
  inlineActionConfirmationState.FREE
)

const emit =
  defineEmits<{
    cancel: []
    confirm: []
  }>()

function openConfirmation() {
  state.value = inlineActionConfirmationState.CONFIRM
}

function handleConfirm() {
  emit('confirm')
  state.value = inlineActionConfirmationState.FREE
}

function handleCancel() {
  emit('cancel')
  state.value = inlineActionConfirmationState.FREE
}
</script>
